<template>
    <html>
        <body class="ovrflow desk_bckgnd_img_login">
            <Header></Header>
            <b-container class="bv-example-row cont_height mob_col_padding">
                <b-row align-h="center" class="dev_lr_margin row_height">
                    <b-col class="xs_col col-sm-10 col-md-7 col-lg-5 col_padding dev_position">
                        <div class="main_div">
                            <b-container class="mob-display brand--logo">
                                <b-row>
                                    <b-col cols="2" class="text-left">
                                        <div class="bck-btn">
                                            <b-button type="Back" variant="outline-light" v-on:click="backAction">
                                                <img src="images/back_blue.png" />
                                            </b-button>
                                        </div>
                                    </b-col>
                                    <b-col cols="8">
                                        <div class="text-center">
                                            <img src="images/inspire-logo.png" alt class="logoImg-class" />
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                            <b-container class>
                                <b-row>
                                    <b-col>
                                        <div class="register_form">
                                            <b-form>
                                                <b-container>
                                                    <b-row>
                                                        <b-col>
                                                            <h5 class="title_text">ENTER GROUP ID</h5>
                                                        </b-col>
                                                    </b-row>
                                                    <div>
                                                        <input
                                                            class="inputstyle"
                                                            id="input-1"
                                                            placeholder="Group ID"
                                                            type="text"
                                                            v-model="groupId"
                                                            autocomplete="off"
                                                            required
                                                        />
                                                    </div>
                                                    <div class="continue-btn">
                                                        <b-row class="justify-content-md-center">
                                                            <b-col lg="10">
                                                                <b-button
                                                                    class="desk-continue-btn"
                                                                    type="contine"
                                                                    v-on:click="onContinue"
                                                                    variant
                                                                    >PROCEED</b-button
                                                                >
                                                            </b-col>
                                                        </b-row>
                                                        <br />
                                                        <br />
                                                        <label v-if="errorStatus" class="errorMessageLabel" id="errorLabel">{{
                                                            errorMessage
                                                        }}</label>
                                                    </div>
                                                </b-container>
                                            </b-form>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <Footer></Footer>
        </body>
    </html>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Header from "@/components/header";
import Footer from "@/components/footer";

export default {
    name: "Home",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            groupId: "",
            store: store,
            errorStatus: false,
            errorMessage: "",
            reg: /^[!@#\\$%\\^\\&*\\)\\(+=._-]{6,}$/g,
        };
    },
    methods: {
        onContinue(evt) {
            evt.preventDefault();
            if (navigator.onLine) {
                if (this.reg.test(this.groupId)) {
                    this.errorStatus = true;
                    this.errorMessage = "Entered Group ID is in-valid";
                } else if (this.groupId.length > 2) {
                    apiCall
                        .apiServiceCall("GetOne", this.groupId.toUpperCase().trim(), "/group/", "", "")
                        .then((response) => {
                            if (response.data.status == 1) {
                                this.store.groupDetail = response.data.data;
                                window.localStorage.setItem("groupID", JSON.stringify(response.data.data.grgcd));
                                //Fetching the logo image from api and storing in local storage
                                if (response.data.data.cssp.length > 0) {
                                    window.localStorage.setItem("logo", JSON.stringify(response.data.data.cssp));
                                    this.store.groupDetail.cssp = JSON.parse(window.localStorage.getItem("logo"));
                                    this.store.isLogoAvailable = true;
                                } else {
                                    window.localStorage.setItem("gnm", JSON.stringify(response.data.data.gnm));
                                    this.store.isLogoAvailable = false;
                                }

                                //Setting the App theme based on the response
                                document.documentElement.style.setProperty("--appHeaderBgColor", response.data.data.color[0].priclr);
                                document.documentElement.style.setProperty("--loginBackgroundColor", response.data.data.color[0].secclr);
                                document.documentElement.style.setProperty("--appTitleTxtColor", response.data.data.color[0].btntxtclr);
                                document.documentElement.style.setProperty("--primaryTextColor", response.data.data.color[0].pritxtclr);
                                document.documentElement.style.setProperty("--textColorLight", response.data.data.color[0].sectxtclr);
                                document.documentElement.style.setProperty("--bannerBackgroundColor", response.data.data.color[0].banbgclr);
                                document.documentElement.style.setProperty(
                                    "--errorMessageTextColor",
                                    response.data.data.color[0].errtxtclr
                                );

                                this.store.enteredGID = this.groupId.toUpperCase();
                                this.$router.push({ path: "/register" });
                            } else {
                                this.errorStatus = true;
                                this.errorMessage = response.data.message;
                            }
                        })
                        .catch((error) => {
                            if (error.response.status == 500) {
                                this.errorStatus = true;
                                this.errorMessage = this.serverProblem;
                            } else if (error.response.status == 401) {
                                setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                            } else if (error.response.status == 504) {
                                this.signout();
                            } else {
                                this.errorStatus = true;
                                this.errorMessage = error.response.data.message;
                            }
                        });
                } else {
                    this.errorStatus = true;
                    this.errorMessage = "Enter valid Group ID";
                }
            } else {
                this.errorStatus = true;
                this.errorMessage = this.checkInternetConnection;
            }
        },
        backAction() {
            this.$router.push({ path: "/home" });
        },
    },
};
</script>
